module.exports = __webpack_public_path__ + "img/profit_active.f0c0ecf7.png";